<template>
  <div id="app" :class="{ 'pc-app': isPcView }">
    <!-- 首次路由仍在解析时保留可见加载态，避免异步路由组件加载期间出现空白。 -->
    <div v-if="!$route.matched.length" class="app-startup" role="status" aria-live="polite">
      <span class="app-startup__spinner" aria-hidden="true"></span>
      <span>正在加载，请稍候...</span>
    </div>
    <template v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
  </div>
</template>
<script>
import { isPcClient } from '@/views/PC/utils';

export default {
  name: 'App',
  data() {
    return {
      isPcView: isPcClient(),
    };
  },
  watch: {
    isPcView(val) {
      document.body.classList.toggle('pc-mode', val);
    },
  },
  mounted() {
    document.body.classList.toggle('pc-mode', this.isPcView);
    if (this.isPcView) {
      this._onResize = () => {
        this.isPcView = isPcClient();
      };
      window.addEventListener('resize', this._onResize);
    }
  },
  beforeDestroy() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
  },
};
</script>
